/**
 * Module dependencies.
 */

import React, { type ComponentProps, type ComponentPropsWithoutRef } from 'react';
import { Title } from 'app/components/atoms/title/title';
import { cn } from 'app/lib/utils';

/**
 * Export `Header` component.
 */

export function Header({ className, ...rest }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('mb-4 flex flex-row items-center justify-between', className)} {...rest} />;
}

/**
 * Export `StyledTitle` component.
 */

export function StyledTitle({ className, ...rest }: ComponentProps<typeof Title>) {
  return <Title className={cn('m-0 p-0', className)} {...rest} />;
}
